import { List, Map } from 'immutable';
import { DEFAULT_SESSION_ID, DEFAULT_PER_PAGE } from '../constants';
import { efectorlistActions } from './actions';
import { EfectorList } from './efector-list';
import { efectorActions } from '../efectores';

export const initialState = new Map({
  currentEfectorListId: DEFAULT_SESSION_ID,
  [DEFAULT_SESSION_ID]: new EfectorList({id: DEFAULT_SESSION_ID, isNew: false })
});

export function efectoreslistsReducer(state = initialState, action) {

  const { type, payload } = action;
  switch (type) {
    /*
    case efectorActions.UPDATE_EFECTOR:
    case efectorActions.CREATE_EFECTOR:
    case efectorActions.FETCH_EFECTOR_FAILED:
    */
    case efectorActions.DELETE_EFECTOR:
    case efectorActions.FETCH_EFECTOR_SUCCESS:
      return state.set(
        state.get('currentEfectorListId'),
        efectoreslistReducer(state.get(state.get('currentEfectorListId')), action)
    );
    case efectorlistActions.FETCH_EFECTORES_SUCCESS:
    case efectorlistActions.FETCH_EFECTORES_PENDING:
      return state.set(
        payload.efectorListId,
        efectoreslistReducer(state.get(payload.efectorListId), action)
      );
    case efectorlistActions.LOAD_EFECTORES_BY_PRACTICE:
    case efectorlistActions.LOAD_EFECTORES:
      return state.merge({
        currentEfectorListId: payload.efectorListId,
        [payload.efectorListId]: efectoreslistReducer(state.get(payload.efectorListId), action)
      });
    case efectorlistActions.UPDATE_PAGINATION:
        return state.set(
          state.get('currentEfectorListId'),
          efectoreslistReducer(state.get(state.get('currentEfectorListId')), action)
        );
    default:
      return state;
  }
}

export const efectoreslistReducer = (state = new EfectorList() , { payload, type }  ) => {
  switch (type) {
    case efectorlistActions.FETCH_EFECTORES_SUCCESS:
     return state.withMutations(efectorList => {
       efectorList
        .merge({
          isNew:false,
          isPending:false,
          count: payload.data.length,
          efectoresIds: mergeIds(efectorList.efectoresIds, payload.data)
       })
       .merge(updatePagination(efectorList, efectorList.currentPage + 1));
      });
    case efectorActions.FETCH_EFECTOR_FAILED:
      return state.set('isPending', false);
    case efectorActions.UPDATE_EFECTOR:
    case efectorActions.CREATE_EFECTOR:
    case efectorlistActions.FETCH_EFECTORES_PENDING:
      return state.set('isPending', true);
    case efectorlistActions.LOAD_EFECTORES_BY_PRACTICE:
    case efectorlistActions.LOAD_EFECTORES:
      return state.withMutations(efectorList => {
        efectorList
          .merge({
            id: payload.efectorListId,
            filters: payload.filters,
            isNew: true
          })
          .merge(updatePagination(efectorList, 1));
        });
    case efectorlistActions.UPDATE_PAGINATION:
      return state.merge(updatePagination(state, payload.page));
    case efectorActions.DELETE_EFECTOR:
        return state.withMutations(efectorList => {

          efectorList
          .merge({
           efectoresIds: efectorList.efectoresIds.filter( efectorId => efectorId !== payload.efectorId )
        })
       });
    case efectorActions.FETCH_EFECTOR_SUCCESS:
      return state.withMutations(efectorList => {
        efectorList
         .merge({
           isPending: false,
           efectoresIds: mergeIds(efectorList.efectoresIds, [payload.efector])
        });
       });
    default:
      return state;
  }
}

function mergeIds(efectoresIds, items) {
  let ids = efectoresIds.toJS();
  let newIds = items.reduce((list, efectorData) => {
    if (ids.indexOf(efectorData.id) === -1) list.push(efectorData.id);
    return list;
  }, []);
  return newIds.length ? new List(ids.concat(newIds)) : efectoresIds;
}

function updatePagination(efectorList, page) {
  let pageCount = Math.ceil(efectorList.efectoresIds.size / DEFAULT_PER_PAGE);
  let currentPage = Math.min(page, pageCount);
  let hasNextPageInStore = currentPage < pageCount;
  let hasPrevPage = currentPage > 1;
  let hasNextPage = hasNextPageInStore || efectorList.nextUrl !== null;

  let to = currentPage * DEFAULT_PER_PAGE
  let from = (to - DEFAULT_PER_PAGE) + 1

  if ( efectorList.total < to )
    to = efectorList.total

  if (from < 1)
    from = 1

  return {
    currentPage,
    hasNextPage,
    hasNextPageInStore,
    hasPrevPage,
    pageCount,
    to,
    from
  };
}
